/* eslint-disable @typescript-eslint/naming-convention */
export enum DatePickerRoleTypeEnum {
	Backdrop = 'backdrop',
	Cancel = 'cancel',
	Save = 'save'
}
